<template>
  <g>
    <path
      d="M8.58984 16.59L13.1698 12L8.58985 7.41L9.99985 6L15.9998 12L9.99984 18L8.58984 16.59Z"
    />
  </g>
</template>
